import React, { useState } from 'react';
interface TabNavigationProps {
  tabs: {
    id: string;
    name: string;
  }[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}
const TabNavigation = ({
  tabs,
  activeTab,
  onTabChange
}: TabNavigationProps) => {
  return <div className="flex border-b border-gray-200 dark:border-dark-border w-full" data-id="element-102">
      {tabs.map(tab => <button key={tab.id} className={`flex-1 py-3 px-2 text-sm font-medium ${activeTab === tab.id ? 'text-text dark:text-dark-text border-b-2 border-text dark:border-dark-text' : 'text-text-meta dark:text-dark-text-meta hover:bg-[#F8F8F8] dark:hover:bg-dark-background-neutral-soft'}`} onClick={() => onTabChange(tab.id)} data-id="element-103">
          {tab.name}
        </button>)}
    </div>;
};
export default TabNavigation;